import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't auto-scroll on draft room routes to preserve user's scroll position
    if (pathname.includes('/draft-room/')) {
      return;
    }
    
    window.scrollTo({
      top: 0,
      behavior: 'instant' // Use instant instead of smooth to prevent scroll conflicts
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop; 